import React from 'react';

import cx from 'classnames';

import Button from 'components/shared/Button';
import i18n from 'i18n';

import { Subtitle } from '../../shared/Subtitle';
import s from './index.module.css';

export function NotifyAgent(props) {
  const { onSendNoti, disabled } = props;
  return (
    <div>
      <div className={cx(s.top, 'custom-flights-notify-agent-top')}>
        <Subtitle title={i18n.t('proposal_content.guest_portal.flight_and_transfers_page.notify_consultant.title')}>
          {i18n.t('proposal_content.guest_portal.flight_and_transfers_page.notify_consultant.description')}
        </Subtitle>
      </div>
      <Button onClick={onSendNoti} htmlType="button" disabled={disabled} className={'custom-flights-notify-agent-btn'}>
        {i18n.t('proposal_content.guest_portal.flight_and_transfers_page.notify_consultant.button.title')}
      </Button>
    </div>
  );
}
